<template>
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="30%" :before-close="closeDialog">
        <el-form :model="approvalForm" ref="approvalForm" label-position="left" label-width="80px"
            :rules="approvalFormRules">
            <el-form-item label="所属公司" prop="company">
                <el-select v-model="approvalForm.company_id" filterable placeholder="请选择所属公司">
                    <el-option v-for="(item, index) in companyList" :key="index" :label="item.title" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审批类型" prop="timing">
                <el-select v-model="approvalForm.timing" filterable placeholder="请选择审核类型">
                    <el-option v-for="(item, index) in typeList" :key="index" :label="item.title" :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="approvalForm.sort"></el-input>
            </el-form-item>
            <el-form-item label="上下线">
                <el-radio-group v-model="approvalForm.is_valid">
                    <el-radio :label="1">上线</el-radio>
                    <el-radio :label="0">下线</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: 'saveApproval',
        props: {
            companyList: {
                type: Array,
                default () {
                    return []
                }
            },
            typeList: {
                type: Array,
                default () {
                    return []
                }
            },
        },
        data() {
            return {
                dialog: {
                    title: '',
                    visible: false,
                    type: ''
                },
                approvalForm: {
                    company_id: '',
                    timing: '',
                    sort: 0,
                    is_valid: 1
                },
                approvalFormRules: {
                    company_id: [{
                        required: true,
                        message: '请选择所属公司',
                        trigger: 'change'
                    }],
                    timing: [{
                        required: true,
                        message: '请选择审核类型',
                        trigger: 'change'
                    }]
                },
            };
        },
        methods: {
            // 显示
            showDialog(type, row) {
                this.dialog.visible = true;
                if (type == 'add') {
                    this.dialog.title = '添加审批规则';
                    this.dialog.type = 'add';
                } else if (type == 'edit') {
                    this.dialog.title = '编辑审批规则';
                    this.dialog.type = 'edit';
                    this.approvalForm = row;
                }
            },

            // 关闭
            closeDialog() {
                this.$refs['approvalForm'].resetFields();
                this.approvalForm = {
                    company_id: '',
                    timing: '',
                    sort: 0,
                    is_valid: 1
                };
                this.dialog = {
                    title: '',
                    visible: false,
                    type: ''
                };
            },

            // 提交
            submit() {
                let that = this;
                let params = that.approvalForm;
                let url = '/api/audit.audit/create'
                that.$refs['approvalForm'].validate((valid) => {
                    if (valid) {
                        this.$post(url, params).then(function (response) {
                            if (response.code == 200) {
                                that.$emit('getTableData');
                                that.closeDialog();
                                that.$message.success(response.msg)
                            } else {
                                that.$message.error(response.msg)
                            }
                        });
                    } else {
                        that.$message.warning('请检查您的填写');
                    }
                });
            }
        }
    };
</script>